import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-assistant-differentiator',
  templateUrl: './assistant-differentiator.component.html',
  styleUrls: ['./assistant-differentiator.component.scss']
})
export class AssistantDifferentiatorComponent implements OnInit {

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    this.getAIDifferentiatorData();
  }

  ai_differentiator_data: any;
  ai_differentiator_data_loaded: boolean = false;
  getAIDifferentiatorData() {
    this.ai_differentiator_data_loaded = false;
    this.commonService
      .getData(
        '/aiadvisorassistantdifferentiator/'
      )
      .subscribe(
        (res: any) => {
          this.ai_differentiator_data = res['data'];
          this.ai_differentiator_data_loaded = true;
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
  }
}
